<template>
  <div class="page-container">
    <search-form ref="SearchFormRef" :exclude="['value8']" @search="onSearch">
      <template #formItem>
        <el-form-item prop="startTime">
          <el-input
            clearable
            placeholder="请输入查询内容"
            v-model="formInfo.searchStr"
            style="width: 360px; margin-top: 3px"
            @input="
              formInfo.searchStr = formInfo.searchStr.replace(/\s+/g, '')
            ">
            <el-select
              v-model="formInfo.searchType"
              slot="prepend"
              style="width: 100px"
              clearable>
              <el-option label="ParentSKU" value="1"></el-option>
              <el-option label="SKU" value="2"></el-option>
              <el-option label="产品编号" value="3"></el-option>
              <el-option label="标题" value="4"></el-option>
              <el-option label="备注" value="5"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
      </template>
      <template #default>
        <el-radio-group v-model="formInfo.uploadStatus" @input="onUploadStatus">
          <el-radio-button label="88">全部</el-radio-button>
          <el-radio-button label="1">待完善</el-radio-button>
          <el-radio-button label="2">待发布</el-radio-button>
          <el-radio-button label="3">审核中</el-radio-button>
          <el-radio-button label="4">成功</el-radio-button>
          <el-radio-button label="5">失败</el-radio-button>
        </el-radio-group>
      </template>
    </search-form>

    <el-row style="margin-top: 20px">
      <el-button type="primary" @click="handleCreate()">创建</el-button>
      <el-button type="success" @click="handleCopy()">复制</el-button>
      <el-button type="danger" @click="handleDelete()">删除</el-button>
      <el-button type="primary" @click="handleUpload()">上传</el-button>
      <el-button type="primary" @click="handleRelease()">发布</el-button>
      <el-button type="primary" @click="handleSync()">同布</el-button>
    </el-row>

    <div class="summary_pagenum">
      <div>
        符合查询条件的产品共
        <span>{{ count }}</span>
        件
      </div>
    </div>
    <div class="table_header">
      <span>已选择产品{{ tableSelectData.length }}件</span>
    </div>

    <el-table
      :data="tableData"
      border
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        align="center"
        width="40px"></el-table-column>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            placement="right"
            v-if="scope.row.imageIdList && scope.row.imageIdList.length > 0"
            :open-delay="600">
            <img :src="scope.row.imageIdList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imageIdList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题/父SKU/商家/分类/完成度"
        width="300px">
        <template slot-scope="scope">
          <!-- <el-popover
            placement="bottom"
            :width="200"
            trigger="click"
            :content="scope.row.globalItemName">
            <div class="ellipsis" slot="reference">
              {{ scope.row.globalItemName }}
            </div>
          </el-popover> -->
          <div>{{ scope.row.globalItemName }}</div>
          <div>{{ scope.row.globalItemSku }}</div>
          <div>{{ scope.row.merchantName }}</div>
          <div>
            {{ scope.row.originalCategoryName }}
            （{{ scope.row.displayCategoryName }}）
          </div>
          <div>{{ scope.row.completeness }}%</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="全球商品状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.uploadStatus === 1" type="info">
            待完善
          </el-tag>
          <el-tag v-else-if="scope.row.uploadStatus === 2" type="warning">
            待上传
          </el-tag>
          <el-tag v-else-if="scope.row.uploadStatus === 3" type="success">
            审核中
          </el-tag>
          <el-tag v-else-if="scope.row.uploadStatus === 4" type="success">
            成功
          </el-tag>
          <template v-else-if="scope.row.uploadStatus === 5">
            <el-tag type="danger">失败</el-tag>
            {{ scope.row.result.error }}
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="发布店铺">
        <template slot-scope="scope">
          <div
            style="display: flex; justify-content: center; align-items: center"
            v-for="item in scope.row.shopeeShopProducts"
            :key="item.id">
            <el-tooltip
              v-if="item.publishStatus === 0"
              effect="dark"
              content="未发布"
              placement="bottom">
              <el-badge class="badge" is-dot type="info"></el-badge>
            </el-tooltip>
            <el-tooltip
              v-else-if="item.publishStatus === 1"
              effect="dark"
              content="发布中"
              placement="bottom">
              <el-badge class="badge" is-dot type="primary"></el-badge>
            </el-tooltip>
            <el-tooltip
              v-else-if="item.publishStatus === 2"
              effect="dark"
              content="发布成功"
              placement="bottom">
              <el-badge class="badge" is-dot type="success"></el-badge>
            </el-tooltip>
            <!-- 发布失败 -->
            <el-tooltip
              v-else-if="item.publishStatus === 3"
              effect="dark"
              :content="item.resultInfoText"
              placement="bottom">
              <el-badge class="badge" is-dot type="danger"></el-badge>
            </el-tooltip>
            {{ item.region }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="角色/更新时间">
        <template slot-scope="scope">
          <div>{{ scope.row.roleName }}</div>
          <div>{{ scope.row.updateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <template>
            <el-button type="primary" @click="handleShow(scope.row)">
              查看
            </el-button>
            <br />
          </template>
          <template
            v-if="
              [1, 2, 5].includes(scope.row.uploadStatus) &&
              [0].includes(scope.row.successUploaded)
            ">
            <el-button type="primary" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <br />
          </template>
          <template v-if="[1].includes(scope.row.successUploaded)">
            <el-button type="primary" @click="handleUpdate(scope.row)">更新</el-button>
            <br />
          </template>
          <template
            v-if="
              [2].includes(scope.row.uploadStatus) &&
              [0].includes(scope.row.successUploaded)
            ">
            <el-button type="primary" @click="handleUpload(scope.row)">
              全球上传
            </el-button>
            <br />
          </template>
          <template
            v-if="
              [4].includes(scope.row.uploadStatus) &&
              [1].includes(scope.row.successUploaded)
            ">
            <el-button type="primary" @click="handleReleaseByOne(scope.row)">
              全球发布
            </el-button>
            <br />
          </template>
          <template>
            <el-button type="success" @click="handleCopy(scope.row)">
              复制
            </el-button>
            <br />
          </template>
          <template
            v-if="
              [1, 2, 4, 5].includes(scope.row.uploadStatus) &&
              [1].includes(scope.row.successUploaded)
            ">
            <el-button type="danger" @click="handleDelete(scope.row)">
              删除
            </el-button>
            <br />
          </template>
          <template
            v-if="
              [3, 4].includes(scope.row.uploadStatus) &&
              [1].includes(scope.row.successUploaded)
            ">
            <el-button type="primary" @click="handleSync(scope.row)">
              同步
            </el-button>
            <br />
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="SKU" min-width="160">
        <template slot-scope="scope">
          <template v-if="scope.row.hasVariant">
            <div v-if="scope.row.isShowAll">
              <div
                v-for="item in scope.row.shopeeGlobalProductSkus"
                :key="item.id">
                {{ item.globalModelSku }}
              </div>
            </div>
            <div v-else-if="scope.row.shopeeGlobalProductSkus">
              <div
                v-for="item in scope.row.shopeeGlobalProductSkus.slice(0, 3)"
                :key="item.id">
                {{ item.globalModelSku }}
              </div>
            </div>
          </template>
          <template v-else>
            <div>{{ scope.row.globalItemSku }}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="库存">
        <template slot-scope="scope">
          <template v-if="scope.row.hasVariant">
            <div v-if="scope.row.isShowAll">
              <div
                v-for="item in scope.row.shopeeGlobalProductSkus"
                :key="item.id">
                {{ item.sellerStock[0].stock }}
              </div>
            </div>
            <div v-else-if="scope.row.shopeeGlobalProductSkus">
              <div
                v-for="item in scope.row.shopeeGlobalProductSkus.slice(0, 3)"
                :key="item.id">
                {{ item.sellerStock[0].stock }}
              </div>
            </div>
          </template>
          <template v-else>
            <div>{{ scope.row.stock }}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="全球价格（USD）">
        <template slot-scope="scope">
          <template v-if="scope.row.hasVariant">
            <div
              style="display: flex; align-items: center"
              :style="{
                justifyContent:
                  scope.row.shopeeGlobalProductSkus &&
                  scope.row.shopeeGlobalProductSkus.length > 3
                    ? 'space-between'
                    : 'center'
              }">
              <div v-if="scope.row.isShowAll">
                <div
                  v-for="item in scope.row.shopeeGlobalProductSkus"
                  :key="item.id">
                  {{ item.originalPrice }}
                </div>
              </div>
              <div v-else-if="scope.row.shopeeGlobalProductSkus">
                <div
                  v-for="item in scope.row.shopeeGlobalProductSkus.slice(0, 3)"
                  :key="item.id">
                  {{ item.originalPrice }}
                </div>
              </div>
              <div
                v-if="
                  scope.row.shopeeGlobalProductSkus &&
                  scope.row.shopeeGlobalProductSkus.length > 3
                "
                class="zhankai_shouqi"
                @click="scope.row.isShowAll = !scope.row.isShowAll">
                <i
                  class="iconfont"
                  :class="scope.row.isShowAll ? 'icon-shouqi' : 'icon-zhankai'"
                  style="color: #fff"></i>
              </div>
            </div>
          </template>
          <template v-else>
            <div>{{ scope.row.originalPrice }}</div>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="page">
      <el-pagination
        :current-page="formInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </el-row>

    <el-dialog title="全球发布" :visible.sync="globalReleaseShow">
      <div>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange">
          全选
        </el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedShops"
          @change="handleCheckedShopsChange">
          <el-checkbox
            v-for="item in globalReleaseList.ok"
            :key="item.shop_id"
            :label="item">
            {{ item.shop_region }} - 店铺
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <ul style="margin: 15px 0">
        <li>已发布</li>
        <li v-for="item in globalReleaseList.no" :key="item.shopId">
          {{ item.shop_region }} - 店铺
        </li>
      </ul>
      <div style="margin: 15px 0 0">
        各店铺商品价格发布后会根据卖家中心的商品价格换算设置自动计算，相关设置请于卖家中心査看
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="globalReleaseShow = false">取消</el-button>
        <el-button type="primary" @click="handleRelease(true)">发布</el-button>
      </span>
    </el-dialog>

    <create-dialog v-model="createShow"></create-dialog>
    <edit-dialog ref="EditDialogRef"></edit-dialog>
    <show-dialog ref="ShowDialogRef"></show-dialog>
    <update-dialog ref="UpdateDialogRef"></update-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from '@/api/api/api'
import SearchForm from './components/searchForm.vue'
import CreateDialog from './components/create.vue'
import EditDialog from './components/edit.vue'
import ShowDialog from './components/show.vue'
import UpdateDialog from './components/update.vue'

export default {
  components: {
    SearchForm,
    CreateDialog,
    EditDialog,
    ShowDialog,
    UpdateDialog
  },
  data() {
    return {
      roleInfo: null,
      formInfo: {
        companyId: '',
        staffId: '',
        searchStr: '', // 查询内容
        searchType: '', // 查询类型
        page: 1,
        size: 20,
        uploadStatus: 88
      },
      count: 1,
      tableData: [],
      tableSelectData: [],
      globalReleaseShow: false,
      globalReleaseList: { info: null, ok: [], no: [] },
      checkAll: false,
      checkedShops: [],
      isIndeterminate: false,
      createShow: false
    }
  },
  computed: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
    this.formInfo.companyId = this.roleInfo.company_id
    this.formInfo.staffId = this.roleInfo.rid
  },
  mounted() {
    this.fetchTableList()
  },
  methods: {
    onSearch() {
      this.formInfo.page = 1
      this.fetchTableList()
    },
    onUploadStatus() {
      this.onSearch()
    },
    //修改size
    handleSizeChange(val) {
      this.formInfo.size = val
      this.onSearch()
    },
    //修改currentPage
    handleCurrentChange(val) {
      this.formInfo.page = val
      this.fetchTableList()
    },
    // 处理table多选
    handleSelectionChange(e) {
      this.tableSelectData = e
    },
    // 获限table数据
    async fetchTableList() {
      try {
        const url =
          Baseurl + '/shopeeGlobalProductInfo/selectShopeeGlobalProducts'
        const searchForm = this.$refs.SearchFormRef.formInfo
        const payload = {
          ...searchForm,
          ...this.formInfo
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.tableData = data.list.map((item) => {
            item.isShowAll = false

            // 处理图片列表
            if (item.imageIdList) {
              item.imageIdList = JSON.parse(item.imageIdList)
              if (item.imageIdList.length > 0) {
                item.imageIdList = item.imageIdList.map(
                  (key) => `https://s-cf-tw.shopeesz.com/file/${key}`
                )
              }
            }
            // 处理失败原因
            if (item.result) {
              item.result = JSON.parse(item.result)
            }
            // 处理发布店铺失败原因
            if (item.shopeeShopProducts) {
              item.shopeeShopProducts = item.shopeeShopProducts.map((key) => {
                key.resultInfo = key.resultInfo && JSON.parse(key.resultInfo)
                if (
                  key.resultInfo &&
                  key.resultInfo.response &&
                  key.resultInfo.response.failed
                ) {
                  key.resultInfoText =
                    key.resultInfo.response.failed.failed_reason
                }
                return key
              })
            }
            // 处理库存信息
            if (item.shopeeGlobalProductSkus) {
              item.shopeeGlobalProductSkus = item.shopeeGlobalProductSkus.map(
                (key) => {
                  key.sellerStock =
                    key.sellerStock && JSON.parse(key.sellerStock)
                  return key
                }
              )
            }

            return item
          })
          this.count = data.total
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理创建
    handleCreate() {
      this.createShow = true
    },
    // 处理复制
    async handleCopy(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }

        await this.$confirm('此操作将复制产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const url = Baseurl + '/shopeeGlobalProductInfo/copyShopeeGlobalProduct'
        const payload = row
          ? {
              ids: [row.id],
              merchantId: 3313275
            }
          : {
              ids: this.tableSelectData.map((item) => {
                return item.id
              }),
              merchantId: 3313275
            }
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理删除
    async handleDelete(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }

        await this.$confirm('此操作将永久删除产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const url =
          Baseurl + '/shopeeGlobalProductInfo/batchDeleteShopeeGloabalProduct'
        const payload = row
          ? [
              {
                id: row.id,
                globalItemId: row.globalItemId,
                merchantId: row.merchantId
              }
            ]
          : this.tableSelectData.map((item) => {
              return {
                id: item.id,
                globalItemId: item.globalItemId,
                merchantId: item.merchantId
              }
            })

        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理编辑
    async handleEdit(row) {
      this.$refs.EditDialogRef.fetchDetails(row.id)
    },
    // 处理查看
    async handleShow(row) {
      this.$refs.ShowDialogRef.fetchDetails(row.id)
    },
    // 处理查看
    async handleUpdate(row) {
      this.$refs.UpdateDialogRef.fetchDetails(row.id)
    },
    // 处理上传
    async handleUpload(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }

        await this.$confirm('此操作将上传产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const url =
          Baseurl + '/shopeeGlobalProductInfo/batchUploadShopeeGlobalProduct'
        const payload = row
          ? {
              ids: [row.id]
            }
          : {
              ids: this.tableSelectData.map((item) => {
                return item.id
              })
            }

        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理发布
    async handleRelease(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        if (!row) {
          await this.$confirm(
            '勾选的所有商品信息，自动发布未完成发布的国家站点?',
            '批量发布',
            {
              confirmButtonText: '发布',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
        }
        const url =
          Baseurl + '/shopeeGlobalProductInfo/releaseShopeeGlobalProduct'

        const payload = row
          ? [
              {
                globalItemId: this.globalReleaseList.info.globalItemId,
                merchantId: this.globalReleaseList.info.merchantId,
                shopeeShopInfos: this.checkedShops.map((item) => {
                  return {
                    shopId: item.shop_id,
                    shopRegion: item.shop_region
                  }
                })
              }
            ]
          : this.tableSelectData.map((item) => {
              return {
                globalItemId: item.globalItemId,
                merchantId: item.merchantId,
                shopeeShopInfos: item.shopeeShopProducts.map((item) => {
                  return {
                    shopId: item.shopId,
                    shopRegion: item.region
                  }
                })
              }
            })
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.fetchTableList()
          if (row) {
            this.globalReleaseShow = false
          }
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理单个发布
    async handleReleaseByOne(row) {
      this.globalReleaseList.info = row
      await Promise.all([
        this.fetchReleaseShopListByOk(row),
        this.fetchReleaseShopListByNo(row)
      ])
      this.globalReleaseShow = true
    },
    // 处理同步
    async handleSync(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }

        await this.$confirm('此操作将同步产品产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const url =
          Baseurl + '/shopeeGlobalProductInfo/selectShopeeGlobalProducts'
        const payload = row
          ? [
              {
                uploadStatus: row.uploadStatus,
                id: row.id,
                merchantId: row.merchantId,
                globalItemId: row.globalItemId
              }
            ]
          : this.tableSelectData.map((item) => {
              return {
                uploadStatus: item.uploadStatus,
                id: item.id,
                merchantId: item.merchantId,
                globalItemId: item.globalItemId
              }
            })
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message('操作成功')
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取可发布的店铺
    async fetchReleaseShopListByOk(info) {
      try {
        const url = Baseurl + '/shopeeGlobalProduct/getPublishableShop'
        const payload = {
          merchant_id: info.merchantId,
          global_item_id: info.globalItemId
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.globalReleaseList.ok = data.response.publishable_shop
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取不发布的店铺
    async fetchReleaseShopListByNo(info) {
      try {
        const url = Baseurl + '/shopeeGlobalProduct/getPublishedList'
        const payload = {
          merchant_id: info.merchantId,
          global_item_id: info.globalItemId
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.globalReleaseList.no = data.response.published_item
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleCheckAllChange(val) {
      this.checkedShops = val ? this.globalReleaseList.ok : []
      this.isIndeterminate = false
    },
    handleCheckedShopsChange(value) {
      console.log(value)
      let checkedCount = value.length
      this.checkAll = checkedCount === this.globalReleaseList.ok.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.globalReleaseList.ok.length
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.prduct_img {
  width: 500px;
  height: 500px;
}
.scope_img {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .badge sup {
  top: 0;
}
.zhankai_shouqi {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background: rgb(168, 168, 168);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  cursor: pointer;
}
.page-container {
  padding-bottom: 60px;
  .summary_pagenum {
    width: 100%;
    background: #f5f5f5;
    margin: 10px 0;
    padding: 10px 20px;
    overflow: hidden;
    color: #585858;
    span {
      color: #2c8dff;
    }
  }
  .table_header {
    width: 100%;
    padding: 10px 20px;
    border: 1px solid #eee;
    border-bottom: 0px;
    overflow: hidden;
    color: #000;
  }
  .page {
    width: 100%;
    height: 50px;
    background-color: white;
    position: fixed;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
